
import {map} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Baseservice } from './baseservice';

import { AuthenticationService } from './authentication.service';

import { HttpClient } from '@angular/common/http';

@Injectable()
export class CarrierAccountService extends Baseservice {

    constructor(http: HttpClient, authentication: AuthenticationService) {
        super('carrieraccount', http, authentication);
    }

    getCarrierAccountByID(id: number) {
        return this.getRequest(`${this.url}/${id}`);
    }

    getUserToLink(email, username, carrier_id) {
        return this.getRequest(`${this.url}/${email}/${username}/${carrier_id}`).pipe(map(response => response));;
    }

    linkCarrrierPerson(carrier_id, person_id, role_served_ind, user_created) {
        return this.getRequest(`${this.url}/${carrier_id}/${person_id}/${user_created}/${role_served_ind}`).pipe(map(response => response));
    }

    changeRoleForCarrierPerson(carrier_id, person_id, role_served_ind, user_created) {
        return this.getRequest(`${this.url}/change/${carrier_id}/${person_id}/${user_created}/${role_served_ind}`).pipe(map(response => response));
    }

    GetLinkedCarrierAccounts(userid) {
        return this.getRequest(`${this.url}/linked/${userid}`).pipe(map(response => response));
    }

    GetLinkedCarrierAccountsByCarrierCode(carrier_code) {
        return this.getRequest(`${this.url}/linkedbycarriercode/${carrier_code}`).pipe(map(response => response));
    }

    EnterCarrierAccountLinkOTP(carrier_person_id, otp) {
        return this.getRequest(`${this.url}/otp/${carrier_person_id}/${otp}`).pipe(map(response => response));
    }

    CarrierAccountDelinkConfirmation(legacy_carrier_code) {
        return this.getRequest(`${this.url}/carrieraccountdelink/${legacy_carrier_code}`).pipe(map(response => response));
    }

    ResendAccountLinkingOTP(user_modified, carrier_person_id) {
        return this.getRequest(`${this.url}/resend/otp/${user_modified}/${carrier_person_id}`).pipe(map(response => response));
    }
    GetCarrierIDByAccountNumber(carrierAccountNumber){
        return this.getRequest(`${this.url}/getcarrieridbyaccountnumber/${carrierAccountNumber}`).pipe(map(response => response));

    }
}
